import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/style/universal.color.ts';

import { liveViewsTypes } from '../../themes/liveViewsTypes';

const { mlbBlack } = COLORS;

const { FULL, SINGLE, TWOCOLS, FULLWIDE, FULLNARROW, SINGLENARROW } = liveViewsTypes;

export const adWidthMap = {
    [FULL]: '86%',
    [FULLNARROW]: '33%',
    [FULLWIDE]: '86%',
    [SINGLE]: 'calc(100% - 32px)',
    [TWOCOLS]: '53%'
};

export const BannerWrapper = styled.div`
    text-align: center;
    width: 100%;

    #ad_top_728 {
        min-height: 90px;
    }
`;

export const MidAdWrapper = styled.div`
    width: 100%;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform:translateX(-50%) translateY(-50%);
    background: ${mlbBlack};
    width: ${({ $type }) => adWidthMap[$type]};
   
    ${({ $type }) => {
        if ($type === FULLNARROW) {
            return `
                margin-top: 0px;
            `;
        }

        if ($type === FULL) {
            return `
                top: 46%;
            `;
        }

        if ($type === TWOCOLS) {
            return `
                left: 525px;
                transform:translateY(-50%);

                @media (max-width: 1200px) {
                    left: 40.5%;
                    width: 50%;
                }
            `;
        }

        if ($type === SINGLE) {
            return `
                margin-left: 16px;
                margin-right: 16px;
                left: 0;
                transform: translateY(-50%);
                margin-top: 0;
            `;
        }

        if ($type === SINGLENARROW) {
            return `
                margin-top: 27px;
            `;
        }
    }};

    > div {
        width: 100%;
        aspect-ratio: 16 / 9;   
    }
`;

export const MidBannerAdWrapper = styled(MidAdWrapper)`
    background-color: transparent;
    width: calc(100% - 32px);

    ${({ $type }) => {
        if ($type === TWOCOLS) {
            return `
                left: 40.5%;
                width: 50%; 
            `;
        }

        if ($type === FULLNARROW || $type === FULL) {
            return `
            width: 100%;    
            `;
        }
    }};

    .ad-responsive-slot {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        ${({ $type }) => {
            if ($type === FULLNARROW || $type === FULL) {
                return `
                top: 40%;
                transformY: translate(-50%);
                `;
            }

            if ($type === TWOCOLS) {
                return `
                top: 45%;
                `;
            }
        }};
    }
`;

export const MidInningAdBackgroud = styled.div`
        background: ${mlbBlack};
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        opacity: var(--gameday-overlay-midinning-opacity);
`;
